import styled                      from 'styled-components';

import { BlockUIVariants         } from 'src/components/common/block-ui';
import { ButtonVariants          } from 'src/components/common/button';
import { DateLabelVariants       } from 'src/components/common/date-label';
import { TabSwitchVariants       } from 'src/components/common/tab-switch';
import { TwoActionDialogVariants } from 'src/components/common/two-action-dialog';
import { DialogVariants          } from 'src/components/common/dialog';

import { NavBarVariants          } from 'src/components/features/common/nav-bar';
import { PieceHelpDialogVariants } from 'src/components/features/inspection/edit/piece-help-dialog';
import { RollVariants            } from 'src/components/features/main/shade-selection/roll';
import { ResultVariants          } from 'src/components/features/main/shade-selection/result';
import { ReportVariants          } from 'src/components/features/main/shade-selection/report';
import { SelectionRatingVariants } from 'src/components/features/main/shade-selection/selection-rating';

import { themeColors, 
         cssFlexColumn           } from 'src/providers/theme/shared';



export type ShadeSelectionLayout = {
  backgroundColor: string;

  paddings: number[];
  scrollableGap: number;

  dividerColor: string;

  navbarVariant: NavBarVariants;

  blockuiVariant: BlockUIVariants;
  dateLabelVariant: DateLabelVariants;
  tabSwitchVariant: TabSwitchVariants;

  rollVariant: RollVariants;
  pieceHelpVariant: PieceHelpDialogVariants;
  addRollButtonVariant: ButtonVariants;
  deleteRollVariant: TwoActionDialogVariants;

  resultVariant: ResultVariants;
  reportVariant: ReportVariants;
  ratingVariant: SelectionRatingVariants;
  ratingDialogVariant: DialogVariants;

  warningDialogVariant: TwoActionDialogVariants;

  generateButtonVariant: ButtonVariants;
  repeatButtonVariant: ButtonVariants;
  ratingButtonVariant: ButtonVariants;
}

export const layout_light: ShadeSelectionLayout = {
  backgroundColor: themeColors.SurfaceBackgroundPrimary,

  paddings: [0, 20, 20, 20],
  scrollableGap: 8,

  dividerColor: themeColors.SecondaryGray3,

  navbarVariant: 'lightwhite',

  blockuiVariant: 'light',
  dateLabelVariant: 'h40black',
  tabSwitchVariant: 'h32',

  rollVariant: 'light',
  pieceHelpVariant: 'light',
  addRollButtonVariant: 'textBig',
  deleteRollVariant: 'light',

  resultVariant: 'light',
  reportVariant: 'light',
  ratingVariant: 'light',
  ratingDialogVariant: 'light',

  warningDialogVariant: 'light',

  generateButtonVariant: 'primaryBig',
  repeatButtonVariant: 'secondaryBig',
  ratingButtonVariant: 'outlinedBig',
}

export const layout_dark: ShadeSelectionLayout = {
  ...layout_light,
}

export const Screen = styled.div<{
  layout: ShadeSelectionLayout,
}>`
  width: 100vw;
  height: 100dvh;

  ${cssFlexColumn};

  background-color: ${(args) => args.layout.backgroundColor};
`

export const ScreenBody = styled.div<{
  layout: ShadeSelectionLayout,
}>`
  ${cssFlexColumn};
  flex-grow: 2;
  padding: ${(args) => args.layout.paddings[0]}px ${(args) => args.layout.paddings[1]}px ${(args) => args.layout.paddings[2]}px ${(args) => args.layout.paddings[3]}px; 
`

export const ScrollableContainer = styled.div<{
  layout: ShadeSelectionLayout,
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.layout.scrollableGap}px;
  padding-bottom: 20px;
  flex-grow: 2;
  overflow: scroll;
`

export const RollDivider = styled.div<{
  layout: ShadeSelectionLayout,
}>`
  border-bottom: 1px solid ${(args) => args.layout.dividerColor};
`

export const ActionsContainer = styled.div<{
  layout: ShadeSelectionLayout,
}>`
  ${cssFlexColumn};
  gap: 12px;
  flex-shrink: 0;
`
